import Node from './shared/Node';
import Block from '../dom/Block';

export default class CatchBlock extends Node {
	block: Block;
	children: Node[];
}